<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card m-2 m-lg-3">
          <div class="card-body">
    
            <div class="row  align-items-center form-header">
            <div class="col mt-4">
              <h4 class="ms-md-2 ms-lg-4 ms-md-4">Rental Payments</h4>
            </div>
            
            <div class="col-12 col-sm-6 col-md-4 d-flex justify-content-end ">
              <llp-button
                classNames="btn-secondary new-btn d-none d-sm-block"
                @click="BackToServices()"
              >
                 Back To Rental Payments
              </llp-button>
               <llp-button
                classNames="btn-secondary new-btn d-block d-sm-none add-btn"
                 @click="BackToServices()"
              >
                Go Back
              </llp-button>
            </div>
          </div>
            <div class="m-lg-4 m-md-4">
              <div class="col-lg-3 col-md-6 col-sm-6" v-if="!rentalRoleId">
                <llp-label
                  id="confirmPasswordLabel"
                  :aria-label="confirPassword"
                  >Landlord Names:</llp-label
                >
                <select
                  id="state"
                  class="form-control select-dropdown"
                  v-model="SelectedName"
                >
                  <option value="" disabled selected>
                    Please select landlord name
                  </option>
                  <option
                    v-for="details in landlordData"
                    :key="details.id"
                    :value="details.id"
                  >
                    {{ details.name }}
                  </option>
                </select>
              </div>
            </div>
            <div v-if="selectedLandlord" class="m-lg-4 m-md-4">
              <div class="col-lg-5 col-md-8 col-sm-12 selected-data">
                <h5>Selected Landlord Details:</h5>

                <div class="card p-4">
                  <div class="row mb-2">
                    <div class="col-lg-4 col-md-6 col-sm-6">
                      <strong>Name:</strong>
                    </div>
                    <div class="col-lg-8 col-md-6 col-sm-6">
                      {{ selectedLandlord.name }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-4 col-md-6 col-sm-6">
                      <strong>Address:</strong>
                    </div>
                    <div class="col-lg-8 col-md-6 col-sm-6">
                      {{ selectedLandlord.address }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-4 col-md-6 col-sm-6">
                      <strong>Pan Number:</strong>
                    </div>
                    <div class="col-lg-8 col-md-6 col-sm-6">
                      {{ maskedPanNumber }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-4 col-md-6 col-sm-6">
                      <strong>Mobile:</strong>
                    </div>
                    <div class="col-lg-8 col-md-6 col-sm-6">
                      {{ selectedLandlord.mobile }}
                    </div>
                  </div>

                  <div class="col-lg-7 col-md-7 col-sm-12 mt-3">
                    <llp-label
                      id="confirmPasswordLabel"
                      :aria-label="confirPassword"
                      >Amount:</llp-label
                    >
                    <llp-input
                      id="confirmpassword"
                      class="w-100"
                      autocomplete="off"
                      v-model="Amount"
                      :errors="validator.Amount.$errors"
                    ></llp-input>
                  </div>

                  <div class="col-lg-7 col-md-7 col-sm-6 mt-2">
                    <llp-button
                      classNames="btn-secondary new-btn"
                      type="button"
                      @click:button="fetchPaymentMethods()"
                    >
                      Proceed To Pay
                    </llp-button>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="rentalRoleId" class="m-lg-4 m-md-4">
              <div class="col-lg-5 col-md-8 col-sm-12">
                <h5>Selected Landlord Details:</h5>
                <div class="card p-4">
                  <div class="row mb-2">
                    <div class="col-lg-4 col-md-6 col-sm-6">
                      <strong>Name:</strong>
                    </div>
                    <div class="col-lg-8 col-md-6 col-sm-6">
                      {{ this.singleLandlordData.name }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-4 col-md-6 col-sm-6">
                      <strong>Address:</strong>
                    </div>
                    <div class="col-lg-8 col-md-6 col-sm-6">
                      {{ this.singleLandlordData.address }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-4 col-md-6 col-sm-6">
                      <strong>Pan Number:</strong>
                    </div>
                    <div class="col-lg-8 col-md-6 col-sm-6">
                      {{ maskedPanNumber }}
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-lg-4 col-md-6 col-sm-6">
                      <strong>Mobile:</strong>
                    </div>
                    <div class="col-lg-8 col-md-6 col-sm-6">
                      {{ this.singleLandlordData.mobile }}
                    </div>
                  </div>

                  <div class="col-lg-7 col-md-7 col-sm-12 mt-3">
                    <llp-label
                      id="amountLabel"
                      :aria-label="amount"
                      >Amount:</llp-label
                    >
                    <llp-input
                      id="amountInput"
                      class="w-100"
                      autocomplete="off"
                      v-model="this.Amount"
                       :errors="validator.Amount.$errors"
                       
                    ></llp-input>
                  </div>

                  <div class="col-lg-7 col-md-7 col-sm-6 mt-2">
                    <llp-button
                      classNames="btn-secondary new-btn"
                      type="button"
                      @click:button="fetchPaymentMethods()"
                    >
                      Proceed To Pay
                    </llp-button>
                  </div>
                </div>
              </div>
            </div>
            <Dialog
              v-model:visible="showPaymentDialog"
              header="Select Payment Method"
               modal
              :style="{ width: '90%', maxWidth: '45rem' }"
              :breakpoints="{'960px': '75vw', '641px': '90vw'}"
                @hide="onHideDialog"
            >
              <div v-if="loading" class="loader-overlay">
                <div class="spinner"></div>
              </div>
              <span class="text-surface-500 dark:text-surface-400 block">
                Choose how you'd like to pay:
              </span>

              <div class="row mt-2">
                <div
                  class="col-6 mb-2"
                  v-for="method in paymentMethods"
                  :key="method.id"
                >
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      :id="method.id"
                      :value="method.value"
                      v-model="selectedPaymentMethod"
                      name="paymentOption"
                      @change="handlePaymentMethodChange(method.value)"

                    />
                    <label class="form-check-label ms-2" :for="method.id">
                      {{ method.name }}
                    </label>
                  </div>
                </div>
              </div>
             
              <div v-if="selectedPaymentMethod === 'Credit Card/Debit Card'">
                <h5>Card details:</h5>
                <div class="row">
                  <div class="mb-2 col-lg-6 col-md-6 col-sm-12">
                    <llp-label>Card Number:</llp-label>
                    <llp-input
                      v-model="cardDetails.cardNumber"
                      class="w-100 mb-2"
                      placeholder="Enter card number"
                      :errors="validator.cardDetails.cardNumber.$errors"
                        @input="formatCardNumber"
                    ></llp-input>
                  </div>
                </div>

                <div class="row">
                  <div class="mb-2 col-lg-6 col-md-6 col-sm-6">
                    <llp-label>Name On Card</llp-label>
                    <llp-input
                      v-model="cardDetails.cardHolderName"
                      class="w-100 mb-2"
                      :errors="validator.cardDetails.cardHolderName.$errors"
                    />
                  </div>
                </div>
               
              </div>
             <div class="row" v-if="this.paymentCharges">
            <div class="col-6">
              <p class="mb-1"><strong>Amount:</strong></p>
              <p class="mb-3"><strong>Service Charge:</strong></p>
            </div>
            <div class="col-6">
              <p class="mb-1">₹{{ paymentCharges.base_amount }}</p>
              <p class="mb-3">₹{{ paymentCharges.charge_amount }}</p>
            </div>
                    </div>
              <div class="flex justify-end gap-2">
                <button
                  class="btn btn-secondary"
                  :load-spinner="payloadSpinner"
                  @click="PayAmount"
                >
                 Pay Now <span v-if="paymentCharges?.total_payable">(₹{{ paymentCharges.total_payable }})</span>

                </button>
              </div>
            </Dialog>
          </div>
        </div>
      </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>
<script>
import NetworkService from "@/services/network.service";

import Dialog from "primevue/dialog";
import _ from 'lodash';
import { useVuelidate } from "@vuelidate/core";

import { cardValidation } from "@/validations/cardValidation";
import {
  formatCardNumber as formatCardNumberUtil,
} from "@/validations/cardFormatters";

export default {
  components: { Dialog },
  setup: () => ({ validator: useVuelidate() }),
  data() {
    return {
      SelectedName: "",
      loading: false,
      payloadSpinner: false,
      rentalRoleId: this.$route.params.id,
      name: "",
      address: "",
      panNumber: "",
      Mobile: "",
      Amount: "",
      selectedLandlord: "",
      serviceId: this.$route.params.serviceId,
      userId: localStorage.getItem("User_id"),
      role_id:localStorage.getItem('role_id'),
      landlordData: [],
      maskedPanNumber: "",
      singleLandlordData: [],
      paymentCharges:null,
      showPaymentDialog: false,
      paymentMethods: [],
      selectedPaymentMethod: "",
      landlord_service_id: "",
       lastCardDigits: "",
        lastCardHolderName: "",
        rentInput: {
      value: "",
      errors: []
    },
      cardDetails: {
        cardNumber: "",
        cardHolderName: "",
      },
       debouncedFetchCharges: null,

    };
  },
  created() {
    this.debouncedFetchCharges = _.debounce(this.fetchPaymentCharges, 2000);
  },
  watch: {
    Amount(newVal) {
    if (newVal !== "") {
      this.validator.Amount.$touch();      
      this.validator.Amount.$validate();   
    }
  },
  
    SelectedName(newVal) {
      if (newVal) {
        this.fetchSelectedLandlordDetails(newVal);
      }
    },
    'cardDetails.cardNumber'() {
    this.tryFetchCharges();
  },
  'cardDetails.cardHolderName'() {
    this.tryFetchCharges();
  }
  },
  beforeUnmount() {
    if (this.debouncedFetchCharges) {
      this.debouncedFetchCharges.cancel();
    }
  },

  mounted() {
    const script = document.createElement("script");
    script.src = "https://sdk.cashfree.com/js/v3/cashfree.js";
    script.async = true;
    document.head.appendChild(script);
    if (this.rentalRoleId) {
      this.fetchingSingleUserLanlordDetails();
    } else if (this.serviceId) {
      this.fetchingLandlordUsers();
    }
  },

validations() {
  return cardValidation;
},
  methods: {
  formatCardNumber() {
  this.cardDetails.cardNumber = formatCardNumberUtil(this.cardDetails.cardNumber );
  this.validator.cardDetails.cardNumber.$touch();
},
 tryFetchCharges() {
  if (this.selectedPaymentMethod !== 'Credit Card/Debit Card') return;
  const cleanNumber = this.cardDetails.cardNumber.replace(/\D/g, '');
  const holderName = this.cardDetails.cardHolderName?.trim();
  if (cleanNumber.length === 16 && holderName) {
    if (this.lastCardDigits !== cleanNumber || this.lastCardHolderName !== holderName) {
      this.lastCardDigits = cleanNumber; 
      this.lastCardHolderName = holderName;
      this.debouncedFetchCharges('Credit Card/Debit Card', {
        card_number: cleanNumber,
      });
    }
  } else {
    this.paymentCharges = null;
  }
},
      handlePaymentMethodChange(methodValue) {
    this.selectedPaymentMethod = methodValue;
       this.paymentCharges = null;
       this.cardDetails.cardNumber = '';
    this.cardDetails.cardHolderName = '';
     if (this.validator?.cardDetails?.cardNumber) {
    this.validator.cardDetails.cardNumber.$reset();
  }
   if (this.validator?.cardDetails?.cardHolderName) {
    this.validator.cardDetails.cardHolderName.$reset();
  }
   if (methodValue !== 'Credit Card/Debit Card') {
    this.fetchPaymentCharges(methodValue);
  }
  
  },
  onHideDialog() {
    NetworkService.resetPaymentDialog(this);
  },
    async fetchPaymentCharges(methodValue, extra = {}) {
      this.debouncedFetchCharges.cancel();
    if (!methodValue) return;
    this.loadingCharges = true;
   this.loading = true;
    try {
      const method = this.paymentMethods.find(m => m.value === methodValue);
      if (!method) {
        throw new Error('Payment method not found');
      }
      const baseAmount = this.selectedLandlord 
        ? this.Amount 
        : this.Amount;
      // Using POST with request data
       const payload = {
          user_id: this.userId,
          method_type: methodValue,
          base_amount: baseAmount,
          ...extra              
        };

      const response = await NetworkService.getPaymentCharges(method.id, this.role_id, payload);
   if (response.success === false) {
          this.$refs.toast.show(
            response.message || 'Unable to fetch payment charges',
            'error'
          );
          return;
        }

        this.paymentCharges = response;
         this.loading = false;
      } catch (err) {
        const msg =
          err?.response?.data?.message || err.message || 'Failed to fetch charges';
        this.$refs.toast.show(msg, 'error');
    } finally {
      this.loadingCharges = false;
         this.loading = false;
    }
  },
    formatExpiry(event) {
      let expiryDate = event.target.value.replace(/\D/g, "");
      if (expiryDate.length > 2) {
        expiryDate =
          expiryDate.substring(0, 2) + "/" + expiryDate.substring(2, 4);
      }
      this.cardDetails.expiry = expiryDate.substring(0, 5);
      event.target.value = this.cardDetails.expiry;
    },

    async fetchingLandlordUsers() {
      try {
        const landlordResponse = await NetworkService.get(
          `get-service-list-dropdown/${this.userId}/${this.serviceId}`
        );

        this.landlordData = landlordResponse.details;
      } catch (error) {
        this.$refs.toast.show("Unable to fetch the user details.", "error");
      }
    },
    async fetchSelectedLandlordDetails(landlordId) {
      this.landlord_service_id = landlordId;
      try {
        const response = await NetworkService.get(
          `get-service-list-for-pay/${landlordId}/${this.userId}/${this.serviceId}`
        );
        this.selectedLandlord = response.details;
        this.Amount = this.selectedLandlord.rent;
        // Optional: Mask PAN number
        if (this.selectedLandlord.pan_number) {
          this.maskedPanNumber = this.selectedLandlord.pan_number.replace(
            /.(?=.{4})/g,
            "*"
          );
        }
      } catch (error) {
        this.$refs.toast.show(
          "Failed to fetching the landlord details",
          "error"
        );
      }
    },

    async fetchingSingleUserLanlordDetails() {
      try {
        const singleUserResponse = await NetworkService.get(
          `get-service-list-for-pay/${this.rentalRoleId}/${this.userId}/${this.serviceId}`
        );
        this.singleLandlordData = singleUserResponse.details;
        if (this.singleLandlordData.pan_number) {
          this.maskedPanNumber = this.singleLandlordData.pan_number.replace(
            /.(?=.{4})/g,
            "*"
          );
        }
        this.Amount = this.singleLandlordData.rent;
      } catch (error) {
        this.$refs.toast.show(
          "Unable to fetching the landlord details.",
          "error"
        );
      }
    },
    BackToServices() {
      this.$router.back();
    },

    async fetchPaymentMethods() {
    if (!this.selectedLandlord && !this.Amount) {
    this.validator.Amount.$touch(); 
    return;
  }
  if (this.selectedLandlord && !this.Amount) {
    this.validator.Amount.$touch(); 
    return;
  }
      this.showPaymentDialog = true;
    this.loading = true;

      try {
        const res = await NetworkService.get("payment-methods-for-pay");
        if (res.status && Array.isArray(res.data)) {
          this.paymentMethods = res.data.map((method) => ({
            id: method.id,
            name: method.payment_method,
            value: method.payment_method,
          }));
          this.loading = false;
        } else {
          this.paymentMethods = [];
          this.loading = false;
          this.$refs.toast.show("No payment methods available", "warning");
        }
      } catch (error) {
        console.log("error",error);
        
        this.$refs.toast.show("Unable to fetch the payment methods", "error");
      }
    },

    async PayAmount() {
      if (!this.selectedPaymentMethod) {
        this.$refs.toast.show("Please select a payment method", "error");
        return;
      }

      if (this.selectedPaymentMethod === "Credit Card/Debit Card") {
        const isValid = await this.validator.$validate();
        if (!isValid) return;
      }

      this.payloadSpinner = true;

      try {
        const selectedMethod = this.paymentMethods.find(
          (method) => method.value === this.selectedPaymentMethod
        );

        const paymentDetails = this.selectedLandlord
          ? {
              user_id: this.userId,
              base_amount: this.Amount,
              service_id: this.serviceId,
              email: this.selectedLandlord.email,
              mobile: this.selectedLandlord.mobile,
              name: this.selectedLandlord.name,
              payment_method_id: selectedMethod.id,
              service_user_id: this.landlord_service_id,
              account_number: this.selectedLandlord.account_number,
              account_holder_name: this.selectedLandlord.account_holder_name,
              bank_name: this.selectedLandlord.bank_name,
              bank_branch: this.selectedLandlord.bank_branch,
              ifsc_code: this.selectedLandlord.ifsc_code,
              beneficiary_id: this.selectedLandlord.beneficiary_id,
              charge_amount:this.paymentCharges.charge_amount,
              amount:this.paymentCharges.total_payable,
              method_type:this.selectedPaymentMethod,
              charge_percent:this.paymentCharges.charge_percent
            }
          : {
              user_id: this.userId,
              base_amount: this.Amount,
              email: this.singleLandlordData.email,
              mobile: this.singleLandlordData.mobile,
              name: this.singleLandlordData.name,
              service_id: this.serviceId,
              payment_method_id: selectedMethod.id,
              service_user_id: this.rentalRoleId,
              account_number: this.singleLandlordData.account_number,
              account_holder_name: this.singleLandlordData.account_holder_name,
              bank_name: this.singleLandlordData.bank_name,
              bank_branch: this.singleLandlordData.bank_branch,
              ifsc_code: this.singleLandlordData.ifsc_code,
              beneficiary_id: this.singleLandlordData.beneficiary_id,
              charge_amount:this.paymentCharges.charge_amount,
              amount:this.paymentCharges.total_payable,
              method_type:this.selectedPaymentMethod,
              charge_percent:this.paymentCharges.charge_percent
            };

        const result = await NetworkService.PaymentService.initiate(
          `get-payment-gateways-for-pay`,
          selectedMethod.id,
          paymentDetails
        );
          console.log("result is ",result);

              if (result.selected_method === 'auropay' && result?.order?.paymentLink) {
            window.location.href = result.order.paymentLink;
            return;
          }
          const paymentSessionId = result?.order?.data?.payment_session_id;
        if (paymentSessionId) {
          const cashfreeResult =
            await NetworkService.PaymentService.processCashfree(
              paymentSessionId
            );
          console.log("cashfreeResult", cashfreeResult);
          this.loading = true;
          setTimeout(async () => {
            await this.verifyPaymentStatus(result.order.data.order_id);
          }, 5000);
         
        } else {
          throw new Error("No payment session ID received from server");
        }
      } catch (error) {
        this.payloadSpinner = false;
        const errorInfo = NetworkService.PaymentService.handleError(error);
        this.$refs.toast.show(errorInfo.message, "error");
      }
    },

   async verifyPaymentStatus(orderId) {
  await NetworkService.PaymentService.verifyAndHandlePaymentStatus(orderId, this);
}
  },
};
</script>